import { type FC, useContext } from 'react';
import { Energy } from '@components/Energy/Energy';

import { RestoreEnergyContext } from '@/components/Modals/RestoreEnergy/context';
import { Button } from '@/components/ui/Button/Button';
import { useAppSelector } from '@/redux/store';

const EnergyButton: FC = () => {
  const energy = useAppSelector((state) => state.user.extendedInfo?.energy);
  const { setIsOpen } = useContext(RestoreEnergyContext);

  const onClick = (): void => {
    if (energy !== undefined && energy < 100) {
      setIsOpen(true);
    }
  };

  return (
    <Button className="!w-auto flex-1" onClick={onClick} variant="transparent">
      <Energy />
    </Button>
  );
};

export { EnergyButton };
